import {
	CONTENT_TYPE_REQUEST_GET,
	CONTENT_TYPE_RESPONSE_GET_FAIL,
	CONTENT_TYPE_RESPONSE_GET_SUCCESS,
} from '../constants/contentTypeConstants';

/**
 * Reducer function for managing content type list.
 *
 * @param {object} state - Current state of the audit log list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const contentTypeListReducer = (state = { contentTypes: {} }, action) => {
	switch (action.type) {
		case CONTENT_TYPE_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case CONTENT_TYPE_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				contentTypes: action.payload,
			};
		case CONTENT_TYPE_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
